import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import {
  IntegrationsMarketplaceHistoryLogsGzDataProvider
} from "../dataProvider/IntegrationsMarketplaceHistoryLogsGzDataProvider";

export class IntegrationsMarketplaceHistoryLogsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrationsMarketplaceHistoryLogsGzDataProvider);
  }
}
